import ReactSelect, { GroupBase, Props } from 'react-select'
import './Select.css'

function Select<
  Option,
  IsMulti extends boolean = false,
  Group extends GroupBase<Option> = GroupBase<Option>,
>({ className, ...rest }: Props<Option, IsMulti, Group>) {
  return (
    <ReactSelect
      {...rest}
      className={`Select__container ${className || ''}`}
      classNamePrefix="Select"
    />
  )
}

export default Select
export * from 'react-select'
